import Player from "@vimeo/player";
import YouTubePlayer from "youtube-player";
var videoBlock = (function () {
	
	let videoPlayer = null;
	let ytPlayer = null;

	function setup() {
		$('.modal-video').on('click', function (evt) {
			evt.preventDefault();

			var w = $(window).outerWidth() >= 1200 ? 1050 : $(window).outerWidth() * .9;
			var isYt = $(this).data('player-type') == 'yt';

			if (isYt) {
				if (ytPlayer == null) {
					ytPlayer = YouTubePlayer('modal-video-holder', { width: w, height: w*(9/16) });
				}
				ytPlayer.loadVideoById($(this).data('video-id'));
				ytPlayer.playVideo();
			}
			else {
				if (videoPlayer == null) {
					var options = {
						id: $(this).data('video-id'),
						width: w
					};

					videoPlayer = new Player('modal-video-holder', options);
					videoPlayer.play();
				} else {
					videoPlayer.loadVideo($(this).data('video-id')).then(() => { videoPlayer.play(); });
				}
			}
		});

		$('#modal_video .close-icon').on('click', function (evt) {
			evt.preventDefault();
			if (videoPlayer != null) {
				videoPlayer.pause();
			}
			if (ytPlayer != null) {
				ytPlayer.stopVideo();
			}
		});
	}

	return {
		init: function () {
			$(function () {
				setup();
			});
		}
	};
})();

export var videoBlock;